/* PDP MOBILE JS v3 — mansset.com */
(function(){
  if(window.innerWidth >= 768) return;

  function getInv(){
    try{ var el=document.getElementById('m-variant-inventory'); if(!el)return{}; return JSON.parse('{'+el.textContent+'}'); }catch(e){return{};}
  }

  function updateStock(){
    var inv=getInv();
    document.querySelectorAll('.m-stock-inline').forEach(function(el){el.remove();});
    var target=null;
    document.querySelectorAll('.m-product-option--button .option-label--selected').forEach(function(t){
      var title=t.parentElement.querySelector('.option-label--title');
      if(title&&/size/i.test(title.textContent)&&!target) target=t;
    });
    if(!target)return;
    var sel=document.querySelector('variant-picker script[data-selected-variant]');
    if(!sel)return;
    try{
      var v=JSON.parse(sel.textContent);
      if(!v||!v.id)return;
      var qty=inv[v.id];
      if(typeof qty==='number'&&qty>0&&qty<20){
        var s=document.createElement('span');
        s.className='m-stock-inline';
        s.textContent='Only '+qty+' left in stock';
        target.after(s);
      }
    }catch(e){}
  }

  /* Умный парсер цены из виджета Loop Subscriptions (ИСПРАВЛЕНО) */
  function getLoopPrice() {
    // 1. Ищем активный блок подписки (Loop использует div role="radio" aria-checked="true", а не обычные input)
    var activeBox = document.querySelector('.loop-w-btn-group-purchase-option-selected, div[role="radio"][aria-checked="true"], .lp-active');

    if (!activeBox) return null;

    // 2. Если выбрана разовая покупка (BUY ONCE), возвращаем null, чтобы скрипт взял стандартную цену товара
    if (activeBox.classList.contains('loop-w-btn-group-purchase-option-onetime') || activeBox.innerText.indexOf('BUY ONCE') !== -1 || activeBox.innerText.indexOf('ONE TIME') !== -1) {
      return null;
    }

    // 3. Пытаемся вытащить точную цену из блока с ценой внутри выбранной опции
    var priceEl = activeBox.querySelector('.loop-w-btn-group-purchase-option-price, .loop-price-money');
    if (priceEl) {
      return priceEl.textContent.trim();
    }

    // 4. Фоллбэк: Вытаскиваем все цифры (цены) из активного блока и берем минимальную (скидочную)
    var matches = activeBox.innerText.match(/[\$£€]\s*\d+[\.,]\d+/g);
    if (matches && matches.length > 0) {
      var minPrice = matches[0];
      var minNum = Infinity;
      for(var i=0; i<matches.length; i++) {
        var num = parseFloat(matches[i].replace(/[^\d\.]/g, ''));
        if (num < minNum) {
          minNum = num;
          minPrice = matches[i];
        }
      }
      return minPrice;
    }
    return null;
  }

  function getPrice(){
    // Приоритет отдаем цене из подписки (если выбрана подписка)
    var loopPrice = getLoopPrice();
    if(loopPrice) return loopPrice;

    // Иначе берем стандартную цену продукта (Buy Once)
    var sid=(document.querySelector('product-info[data-section-id]')||{dataset:{}}).dataset.sectionId;
    var el=document.getElementById('m-product-price-mobile-'+sid) || document.querySelector('.m-product-price');
    if(!el) return '';
    var item=el.querySelector('.m-price-item--sale')||el.querySelector('.m-price-item--regular')||el.querySelector('.m-price-item');
    return item?item.textContent.trim():'';
  }

  function injectPrice(btn){
    if(!btn)return;
    var txt=btn.querySelector('.m-add-to-cart--text');
    if(!txt)return;
    
    var p = getPrice();
    var existingSpan = btn.querySelector('.m-atc-price');

    if(!p || btn.disabled){
      if(existingSpan) existingSpan.remove();
      return;
    }

    if(existingSpan) {
      if(existingSpan.textContent.trim() !== p.trim()) {
        existingSpan.textContent = p + ' ';
      }
    } else {
      var s=document.createElement('span');
      s.className='m-atc-price';
      s.textContent=p+' ';
      txt.parentNode.insertBefore(s,txt);
    }
  }

  function updatePrice(){
    document.querySelectorAll('.m-sticky-addtocart .m-add-to-cart').forEach(injectPrice);
    document.querySelectorAll('.m-product-form--main .m-add-to-cart').forEach(injectPrice);
  }

  /* Жесткий контроль кнопки ATC, чтобы Loop не стирал нашу цену */
  function observeATCButtons() {
    document.querySelectorAll('.m-add-to-cart').forEach(function(btn) {
      if(btn.dataset.priceObserved) return;
      btn.dataset.priceObserved = '1';
      
      var obs = new MutationObserver(function() {
        obs.disconnect(); // Отключаем, чтобы не зациклить
        injectPrice(btn);
        obs.observe(btn, {childList: true, characterData: true, subtree: true});
      });
      obs.observe(btn, {childList: true, characterData: true, subtree: true});
    });
  }

  document.addEventListener('click',function(e){
    // Триггер Quickshop
    var trigger=e.target.closest('.m-quick-shop-trigger');
    if(trigger){
      e.preventDefault();
      var card=trigger.closest('.m-product-card');
      if(card){
        var qvBtn=card.querySelector('.m-product-quickview-button');
        if(qvBtn)qvBtn.click();
      }
    }
    
    // Обновление цены при клике по любому элементу Loop Subscriptions
    if(e.target.closest('[class*="lp-"], [class*="loop-"], label, [class*="selling"]')){
      setTimeout(updatePrice, 50);
      setTimeout(updatePrice, 150);
      setTimeout(updatePrice, 300);
    }
  });

  document.addEventListener('change', function(e){
    // Обновление при переключении радио-кнопок
    if(e.target.tagName === 'INPUT' && (e.target.name === 'selling_plan' || e.target.type === 'radio' || e.target.name === 'purchaseType')) {
      setTimeout(updatePrice, 50);
      setTimeout(updatePrice, 150);
      setTimeout(updatePrice, 300);
    }
  });

  function init(){
    updateStock(); updatePrice(); observeATCButtons();
    if(window.MinimogEvents&&window.MinimogTheme){
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange,function(){setTimeout(updateStock,200);setTimeout(updatePrice,200);setTimeout(runFixes, 200);});
    }
    var sel=document.querySelector('variant-picker script[data-selected-variant]');
    if(sel) new MutationObserver(function(){setTimeout(updateStock,100);setTimeout(updatePrice,100);setTimeout(runFixes, 100);}).observe(sel,{childList:true,characterData:true,subtree:true});
    var sid=(document.querySelector('product-info[data-section-id]')||{dataset:{}}).dataset.sectionId;
    var pe=document.getElementById('m-product-price-mobile-'+sid);
    if(pe) new MutationObserver(function(){setTimeout(updatePrice,100);}).observe(pe,{childList:true,subtree:true,characterData:true});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(init,500);});
  else setTimeout(init,500);
  window.addEventListener('load',function(){setTimeout(init,1000);});
  
  /* === Subscription price label === */
  function addSubPrices(){
    document.querySelectorAll('.m-product-card, .ms-recs__card, .ms-rv__card').forEach(function(card){
      if(card.querySelector('.ms-sub-price')) return;
      var tags = card.dataset.tags || card.querySelector('[data-tags]')?.dataset.tags || '';
      var hasTag = tags.indexOf('subscription') !== -1;
      
      var loopEl = card.querySelector('[class*="lp-product-card"], [class*="selling-plan"]');
      if(loopEl) hasTag = true;
      if(!hasTag) return;

      var priceEl = card.querySelector('.m-product-card__price, .ms-recs__price-row, .ms-rv__price-row');
      if(!priceEl) return;
      var mainPrice = priceEl.querySelector('.m-price-item--sale, .m-price-item--regular, .m-price-item, .ms-recs__price, .ms-rv__price');
      if(!mainPrice) return;

      var loopPrice = null;
      if(loopEl){
        var lp = loopEl.querySelector('.money, [class*="price"]');
        if(lp) loopPrice = lp.textContent.trim();
      }
      if(!loopPrice){
        var raw = mainPrice.textContent.trim().replace(/[^0-9.]/g,'');
        var num = parseFloat(raw);
        if(num) loopPrice = '$' + (num * 0.65).toFixed(2);
      }
      if(!loopPrice) return;

      var sub = document.createElement('div');
      sub.className = 'ms-sub-price';
      sub.style.cssText = 'font-family:Anek Tamil,sans-serif;font-size:13px;font-weight:600;color:#E84E4E;text-decoration:none;margin-bottom:2px;';
      sub.textContent = loopPrice + ' Subscription';
      priceEl.parentNode.insertBefore(sub, priceEl);
    });
  }
  setTimeout(addSubPrices, 1500);
  setTimeout(addSubPrices, 3000);
  new MutationObserver(function(){setTimeout(addSubPrices,500);}).observe(document.body,{childList:true,subtree:true});
  
  /* === Dynamic checkout — Убираем рамки у обертки, чтобы не было двойной рамки === */
  function styleDynCheckout(){
    document.querySelectorAll('.m-product-dynamic-checkout').forEach(function(wrapper){
      wrapper.style.setProperty('background', 'transparent', 'important');
      wrapper.style.setProperty('border', 'none', 'important');
      wrapper.style.setProperty('box-shadow', 'none', 'important');
    });
  }

  /* === Soldout sizes — show "S | SOLD OUT", make clickable === */
  function fixSoldout(){
    document.querySelectorAll('.m-product-option--button .m-product-option--node.soldout, .m-product-option--button .m-product-option--node.disabled, .m-product-option--button .m-product-option--node__unavailable').forEach(function(node){
      if(node.dataset.soldoutFixed) return;
      node.dataset.soldoutFixed = '1';

      node.style.setProperty('pointer-events', 'auto', 'important');
      node.style.setProperty('cursor', 'pointer', 'important');
      
      var input = node.querySelector('input');
      if(input) {
        input.removeAttribute('disabled');
        input.classList.remove('disabled');
        input.style.setProperty('pointer-events', 'auto', 'important');
      }

      var extraLabel = node.querySelector('.variant-sold-out-label');
      if(extraLabel) extraLabel.style.setProperty('display', 'none', 'important');

      var label = node.querySelector('.m-product-option--node__label, label');
      if(!label) return;
      label.style.setProperty('pointer-events', 'auto', 'important');

      label.querySelectorAll('.m\\:visually-hidden, .label-unavailable').forEach(function(el){ el.remove(); });
      var rawText = label.textContent.replace(/SOLD OUT/gi, '').replace(/\|/g, '').replace(/\//g, '').trim();
      
      if(!rawText) return;

      label.innerHTML = '<span class="ms-soldout-wrap" style="position:relative;font-family:Anek Tamil, sans-serif !important; z-index:10; display:inline-flex; align-items:center; justify-content:center; gap:4px; font-size:16px; font-weight:600; color:#444; width:100%; height:100%; pointer-events:none;"><span>' + rawText + '</span><span style="font-size:16px; font-weight:700;">| SOLD OUT</span></span>';
    });
  }

  function runFixes(){
    styleDynCheckout();
    fixSoldout();
    observeATCButtons();
  }

  setTimeout(runFixes, 800);
  setTimeout(runFixes, 2000);
  setTimeout(runFixes, 4000);
  window.addEventListener('load', function(){ setTimeout(runFixes, 1500); });
  new MutationObserver(function(){ setTimeout(runFixes, 300); }).observe(document.body, {childList:true, subtree:true});
})();